import { FirstPartyAppId } from 'owa-m365-acquisitions/lib/data/M365AppId';
import { isFeatureEnabled } from 'owa-feature-flags';
import { isSearchPlusChatFeatureEnabled } from './isSearchPlusChatFeatureEnabled';
import { isCalendarCopilotSearchEnabled } from 'owa-copilot-settings-utils';
import { getGlobalSettingsAccountMailboxInfo } from 'owa-account-source-list-store';

/**
 * Helper function to determine if the current module and app combination
 * supports the sparkle search icon for Search Plus Chat feature.
 * @param currentModule - The current module name
 * @param selectedApp - The currently selected app ID
 * @returns true if sparkle icon is supported for this module/app combination
 */
export function isSparkleIconSupportedForModule(
    currentModule: string | undefined,
    selectedApp: string | undefined
): boolean {
    if (!currentModule || !selectedApp) {
        return false;
    }

    switch (currentModule) {
        case 'Mail':
            return isSearchPlusChatFeatureEnabled() && selectedApp === FirstPartyAppId.Mail;
        case 'Calendar':
            return (
                isFeatureEnabled('cal-ai-search-suggestion') &&
                isCalendarCopilotSearchEnabled(getGlobalSettingsAccountMailboxInfo()) &&
                selectedApp === FirstPartyAppId.Calendar
            );
        default:
            return false;
    }
}
